import { z } from 'zod';
import { AccountAuditSchema } from '../types/account.js';
import { DataSourceSchema, type DataSourcesTableItem } from '../types/data-source.js';
import { UserAuditSchema } from '../types/user.js';

// Re-export the core schema from types
export { DataSourceSchema } from '../types/data-source.js';
export type { DataSourcesTableItem } from '../types/data-source.js';

export const ApiDataSourceSchema = z
  .object({
    id: z.number(),
    identifier: z.string(),
    name: z.string(),
    createdOn: z.coerce.date(),
    createdBy: z.number().optional().nullable(),
  })
  .transform((ds) => ({
    id: ds.id,
    identifier: ds.identifier,
    name: ds.name,
    createdOn: ds.createdOn ?? null,
    createdBy: ds.createdBy,
  }));

// API request schemas for app-v1 endpoints
export const CreateDataSourceSchema = z.object({
  identifier: z.string(),
  name: z.string(),
});

export const UpdateDataSourceSchema = z.object({
  identifier: z.string().optional(),
  name: z.string().optional(),
});

export const FetchDataSourcesResponseModel = z.object({
  dataSources: z.array(DataSourceSchema),
});

export const FetchDataSourcesResponseApi = z.object({
  dataSources: z.array(ApiDataSourceSchema),
});

export const FetchDataSourceResponseApi = z.object({
  dataSource: ApiDataSourceSchema,
});

export const FetchDataSourceResponseModel = z.object({
  dataSource: DataSourceSchema,
});

export const FetchDataSourceUsersResponseModel = z.object({
  users: z.array(UserAuditSchema),
});

export const FetchDataSourceAccountsResponseModel = z.object({
  accounts: z.array(AccountAuditSchema),
});

export const CreateDataSourceResponseApi = z.object({
  dataSource: ApiDataSourceSchema,
});

export const CreateDataSourceResponseModel = z.object({
  dataSource: DataSourceSchema,
});

export const UpdateDataSourceResponseApi = z.object({
  dataSource: ApiDataSourceSchema,
});

export const UpdateDataSourceResponseModel = z.object({
  dataSource: DataSourceSchema,
});

// Namespace types for API operations
export namespace CreateDataSource {
  export type Request = z.infer<typeof CreateDataSourceSchema>;
  export type Response = {
    dataSource: DataSourcesTableItem;
  };
}

export namespace UpdateDataSource {
  export type Request = {
    id: number;
    identifier?: string;
    name?: string;
  };
  export type Response = {
    dataSource: DataSourcesTableItem;
  };
}
